import { ProductCategoriesLink } from "components/Navbar/types"
import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { selectUserInfo } from "store/user/userSlice"
import { UserStatusTypes } from "types"
import { Box } from "@strapi/design-system"

export const ActiveUserLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { status: userStatus, username } = useAppSelector(selectUserInfo)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)

  useEffect(() => {
    if (!username) navigate("/login", { replace: true })
    else if (userStatus)
      if (userStatus !== UserStatusTypes.ACTIVE) navigate("/activate-account", { replace: true })
      else if (location.pathname === "/activate-account" && userStatus === UserStatusTypes.ACTIVE)
        navigate(ProductCategoriesLink.MAKEUP, { replace: true })

    setIsCheckingAuth(false)
  }, [userStatus, navigate, location.pathname, username])

  if (isCheckingAuth)
    return (
      <Box
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    )

  return <Outlet />
}
